import { Link } from 'react-router-dom'

import LegalPage from './index'
import { TRoutes } from '../../shared/const'

/* Inhaltlich massgeblich: Junior/rechtstexte/nutzungsbedingungen.md (Stand August 2026). */
export default function Nutzungsbedingungen() {
	return (
		<LegalPage title="Nutzungsbedingungen" stand="August 2026">
			<h2>1. Geltungsbereich und Betreiber</h2>
			<p>
				Diese Nutzungsbedingungen regeln die Nutzung der Plattform „Junior Datenbank" (erreichbar unter{' '}
				<a href="https://company.junior.cc">company.junior.cc</a>, nachfolgend „Plattform"), betrieben vom
				Verein „Junior Achievement Austria" – Unternehmerische Praxis- und Kompetenzbildung, Heinrichsgasse
				3/1/Top 8+9, 1010 Wien, ZVR-Zahl 252077520 (nachfolgend „Betreiber", „wir"). Die technische Umsetzung
				und der Betrieb erfolgen durch die DaVinciLab GmbH im Auftrag des Betreibers.
			</p>
			<p>
				Mit der Registrierung bzw. der Nutzung der Plattform erklären Sie sich mit diesen Nutzungsbedingungen
				einverstanden. Für die Teilnahme an JA Austria Programmen gelten ergänzend die jeweiligen
				Programmunterlagen und Einverständniserklärungen zur Programmteilnahme von Junior Achievement Austria;
				bei Widersprüchen gehen diese den vorliegenden Nutzungsbedingungen vor.
			</p>

			<h2>2. Leistungsbeschreibung</h2>
			<p>Die Plattform dient der Verwaltung der JA Austria Programme, insbesondere:</p>
			<ul>
				<li>Registrierung und Verwaltung von Junior Companies und deren Mitarbeiter:innen,</li>
				<li>Erstellung und Verwaltung von Halbjahres- und Jahresberichten, Rechnungen und Dokumenten,</li>
				<li>Ausstellung von Urkunden und Zertifikaten,</li>
				<li>Vermittlung von Unterstützer:innen (Wirtschaftsexpert:innen, Jurymitglieder, Trainer:innen),</li>
				<li>
					Kommunikation zwischen Schüler:innen, Lehrkräften, Unterstützer:innen und der Programmorganisation,
				</li>
				<li>öffentliche Präsentation der teilnehmenden Junior Companies.</li>
			</ul>
			<p>
				Die Nutzung der Plattform ist unentgeltlich. Ein Rechtsanspruch auf die Nutzung oder auf bestimmte
				Funktionen besteht nicht.
			</p>

			<h2>3. Registrierung und Nutzerkonto</h2>
			<ol>
				<li>
					Die Nutzung der geschützten Bereiche setzt ein Nutzerkonto voraus. Selbst registrieren können sich
					Schüler:innen und Lehrkräfte teilnehmender Schulen sowie Unterstützer:innen; weitere Konten werden
					durch Einladung oder durch die Programmadministration angelegt.
				</li>
				<li>
					Bei der Registrierung sind wahrheitsgemäße und vollständige Angaben zu machen; Änderungen sind im
					Profil aktuell zu halten.
				</li>
				<li>
					Das Konto ist personenbezogen und nicht übertragbar. Die Zugangsdaten sind geheim zu halten.
					Besteht der Verdacht, dass Dritte Zugriff auf das Konto haben, ist das Passwort unverzüglich zu
					ändern und der Betreiber zu informieren.
				</li>
				<li>
					Unterstützer:innen-Profile werden erst nach Prüfung und Freigabe durch die Programmadministration
					aktiviert. Ein Anspruch auf Freigabe besteht nicht.
				</li>
				<li>
					Der Betreiber kann die Bestätigung der E-Mail-Adresse (Doppel-Opt-in) sowie bei Lehrkräften eine
					Verifizierung voraussetzen.
				</li>
			</ol>

			<h2>4. Minderjährige Nutzer:innen</h2>
			<p>
				Die Plattform richtet sich programmbedingt auch an minderjährige Schüler:innen. Für die Teilnahme
				minderjähriger Schüler:innen ist die Zustimmung der Erziehungsberechtigten erforderlich; der
				entsprechende Nachweis (Elternbestätigung) ist über die Plattform bereitzustellen. Die Elternbestätigung
				deckt auch die Nutzung dieser Plattform ab und verweist auf die Datenschutzerklärung. Lehrkräfte
				unterstützen die Schüler:innen bei der ordnungsgemäßen Nutzung der Plattform.
			</p>

			<h2>5. Pflichten der Nutzer:innen, verbotene Nutzung</h2>
			<p>Bei der Nutzung der Plattform ist es untersagt:</p>
			<ul>
				<li>
					rechtswidrige, beleidigende, diskriminierende, jugendgefährdende oder sonst unangemessene Inhalte
					einzustellen oder hochzuladen;
				</li>
				<li>
					Rechte Dritter zu verletzen, insbesondere Urheber-, Marken-, Persönlichkeits- und
					Datenschutzrechte (z. B. durch Hochladen von Fotos oder Dokumenten ohne Zustimmung der abgebildeten
					bzw. betroffenen Personen);
				</li>
				<li>
					Schadsoftware zu verbreiten, Sicherheitsmechanismen zu umgehen, die Plattform automatisiert
					auszulesen oder ihre Verfügbarkeit zu beeinträchtigen;
				</li>
				<li>Zugangsdaten Dritter zu verwenden oder sich als andere Person auszugeben;</li>
				<li>
					über die Plattform erlangte personenbezogene Daten anderer Nutzer:innen zweckwidrig zu verwenden,
					an Dritte weiterzugeben oder für Werbung zu nutzen;
				</li>
				<li>die Plattform für kommerzielle Zwecke außerhalb der JA Austria Programme zu nutzen.</li>
			</ul>

			<h2>6. Inhalte der Nutzer:innen</h2>
			<ol>
				<li>
					Für Inhalte, die Nutzer:innen einstellen oder hochladen (z. B. Firmenprofile, Geschäftsideen,
					Logos, Berichte, Dokumente, Fotos, Ticketanhänge), ist die jeweilige Nutzer:in bzw. deren
					Schülerfirma verantwortlich. Die Rechte an diesen Inhalten verbleiben bei den jeweiligen
					Urheber:innen.
				</li>
				<li>
					Mit dem Einstellen räumen die Nutzer:innen dem Betreiber das nicht-exklusive, zeitlich auf die
					Programmteilnahme beschränkte Recht ein, die Inhalte zum Zweck des Plattformbetriebs und der
					Programmabwicklung zu speichern, zu verarbeiten und — soweit vorgesehen (z. B. öffentliche
					Firmenpräsentation) — anzuzeigen.
				</li>
				<li>Die Nutzer:innen sichern zu, über die erforderlichen Rechte an den eingestellten Inhalten zu verfügen.</li>
				<li>
					Der Betreiber ist berechtigt, Inhalte, die gegen diese Nutzungsbedingungen oder geltendes Recht
					verstoßen, ohne Vorankündigung zu entfernen.
				</li>
			</ol>

			<h2>7. Verfügbarkeit, Wartung und jährlicher Daten-Reset</h2>
			<ol>
				<li>
					Der Betreiber bemüht sich um eine möglichst unterbrechungsfreie Verfügbarkeit der Plattform,
					übernimmt hierfür jedoch keine Gewähr. Wartungsarbeiten, Weiterentwicklungen oder Umstände
					außerhalb des Einflussbereichs des Betreibers können zu vorübergehenden Einschränkungen führen.
				</li>
				<li>
					<strong>Jährlicher Reset:</strong> Am Ende jedes Schuljahrs werden die Junior Companies samt
					zugehörigen Daten und Dokumenten sowie die Konten der Schüler:innen programmgemäß gelöscht.
					Nutzer:innen sind selbst dafür verantwortlich, benötigte Unterlagen (z. B. Urkunden, Berichte)
					rechtzeitig vorher herunterzuladen. Ist ein Reset-Termin geplant, weist die Plattform vorab darauf
					hin (Mitteilung und E-Mail); ein Anspruch auf eine solche Erinnerung besteht nicht.
				</li>
				<li>Ein Anspruch auf dauerhafte Speicherung von Inhalten besteht nicht.</li>
			</ol>

			<h2>8. Sperrung und Beendigung</h2>
			<ol>
				<li>
					Der Betreiber kann Konten vorübergehend sperren oder dauerhaft löschen, wenn Nutzer:innen gegen
					diese Nutzungsbedingungen oder geltendes Recht verstoßen, falsche Angaben gemacht haben oder ihr
					Konto missbräuchlich verwendet wird.
				</li>
				<li>
					Nutzer:innen können die Löschung ihres Kontos jederzeit beim Betreiber beantragen;
					Unterstützer:innen können ihr Profil zudem selbst über die Plattform löschen (Anonymisierung).
					Gesetzliche Aufbewahrungspflichten bleiben unberührt.
				</li>
				<li>Mit Ende der Programmteilnahme endet auch das Nutzungsrecht an der Plattform.</li>
			</ol>

			<h2>9. Haftung</h2>
			<ol>
				<li>
					Der Betreiber haftet unbeschränkt für Schäden aus der Verletzung von Leben, Körper oder Gesundheit
					sowie für Vorsatz und grobe Fahrlässigkeit.
				</li>
				<li>
					Im Übrigen ist die Haftung des Betreibers — soweit gesetzlich zulässig — für leichte Fahrlässigkeit
					ausgeschlossen. Dies gilt insbesondere für Datenverluste (siehe Punkt 7), entgangenen Gewinn und
					mittelbare Schäden. Die Plattform wird unentgeltlich bereitgestellt.
				</li>
				<li>
					Für Inhalte von Nutzer:innen sowie für Inhalte externer, verlinkter Websites übernimmt der
					Betreiber keine Haftung.
				</li>
				<li>
					Die Junior Companies sind pädagogische Übungsfirmen; für deren Geschäftstätigkeit, Angaben und
					Inhalte haften die jeweiligen Teilnehmer:innen nach Maßgabe der Programmbedingungen.
				</li>
			</ol>

			<h2>10. Datenschutz</h2>
			<p>
				Informationen zur Verarbeitung personenbezogener Daten finden Sie in der{' '}
				<Link to={TRoutes.DATENSCHUTZ}>Datenschutzerklärung</Link>.
			</p>

			<h2>11. Änderungen dieser Nutzungsbedingungen</h2>
			<p>
				Der Betreiber kann diese Nutzungsbedingungen mit Wirkung für die Zukunft ändern, wenn dies aufgrund
				geänderter rechtlicher, technischer oder organisatorischer Rahmenbedingungen erforderlich ist. Über
				wesentliche Änderungen werden registrierte Nutzer:innen in geeigneter Weise informiert (z. B. per
				E-Mail oder Hinweis auf der Plattform). Widersprechen Nutzer:innen der Änderung, kann das
				Nutzungsverhältnis beendet werden.
			</p>

			<h2>12. Schlussbestimmungen</h2>
			<ol>
				<li>
					Es gilt österreichisches Recht unter Ausschluss der Verweisungsnormen des internationalen
					Privatrechts und des UN-Kaufrechts.
				</li>
				<li>
					Gerichtsstand ist — soweit gesetzlich zulässig — das sachlich zuständige Gericht in Wien. Für
					Verbraucher:innen gelten die gesetzlichen Gerichtsstände (§ 14 KSchG).
				</li>
				<li>
					Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein oder werden, bleibt die
					Wirksamkeit der übrigen Bestimmungen davon unberührt.
				</li>
			</ol>
			<p>
				Kontakt: <a href="mailto:info@junior.cc">info@junior.cc</a>
			</p>
		</LegalPage>
	)
}
